<template>
  <div class="access-container">
    <div class="access-header align-items-center">
      <img
        v-bind:src="require(`@/assets/img/BourseEchange.png`)"
        class=""
        alt=""
      />
      <div class="">
        <div class="headline">Echanges Agris</div>
        <div class="subline">Accès aux démos privées Echanges Agris</div>
      </div>
    </div>
    <div class="access-apps">
      <section class="products">
        <template
          v-for="product in products"
          :key="product.id_product"
        >
          <div v-if="product.app === 'ECA'" class="product">
            <img
              class="logo-product"
              src="@/assets/img/BourseEchange.png"
            />
            <div class="mx-1 d-flex flex-row">
              <i
                class="fas fa-user mr-2"
                data-toggle="tooltip"
                data-placement="right"
                title="Accès utilisateur"
              ></i
              ><i
                class="fas fa-chart-bar"
                data-toggle="tooltip"
                data-placement="right"
                title="Accès statistiques"
              ></i>
            </div>
            <div style="width: 300px">{{ product.description }}</div>
            <button
              class="access-button"
              @click="toECA(product.login, product.password, product.env)"
            >
              Accès Echanges Agris
            </button>
          </div>
          <div v-if="product.app === 'ECA'"  class="info">
            <div>
              <strong>Info démo :</strong> <br>
              3 modèles de fichiers vous permettrons d'importer des données via la partie Admin > Gestion des données.
              Vous pourrez ajouter à ces fichiers vos propres données en respectant le format des fichiers. 
            </div>

            <div class="downloadList">
              <button
                class="download-button"
                @click="downloadFile('bl_template')"
              >
              BLs</button>
              <button
                class="download-button"
                @click="downloadFile('products_template')"
              >Produits</button>
              <button
                class="download-button"
                @click="downloadFile('users_template')"
              >Utilisateurs</button>
            </div>
            </div>
        </template>
        <div v-if="!products?.length" class="product">Accès à aucune application</div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccessECA",
  props: ["products"],
  setup() {
    function toECA(login, mdp, env) {
      this.hasError = false;
      this.result = "";
      env === "Démo"
        ? (this.url = "https://demo.boursedechange.com/?jetonsso=")
        : (this.url = "https://dev-front.digitappro.io/?jetonsso=");
      const jeton = window.btoa(
       
          encodeURIComponent(
            "loginTiers=" + login.trim() + "&password=" + mdp.trim()
          )
        
      );
      const uri = this.url + jeton;
      const encoded = encodeURI(uri);
      window.open(encoded, "_blank");
    }
    function downloadFile(fileName){
      const filePath = `templates/ECA/${fileName}.xlsx`;
      const fileUrl = `${process.env.VUE_APP_BASE_URL}${filePath}`;
      const saveAsFileName = `${fileName}.xlsx`;

      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = saveAsFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return {
      toECA,
      downloadFile
    };
  },
};
</script>

<style scoped lang="scss">
.access-container {
  flex-grow: 1;
  border-radius: var(--border-radius, 6px);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  border: none;
  padding: 1rem;
  margin-bottom: 1rem;
  .access-header {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
    img {
      max-width: 100px;
      border-radius: 50%;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    }
  }
  .headline {
    font-size: 17px;
    margin-top: 0;
    margin-bottom: 10px;
    font-weight: 700;
  }
  .subline {
    font-size: 14px;
    color: var(--mainGreen);
  }
}
.products {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;
  .product {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    // box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border: 1px solid #e9e9e9;
    // background-color: rgba($color: #000000, $alpha: 0.01);
    border-radius: 3px;
    max-height: 150px;
    .logo-product {
      height: 50px;
    }
    .access-indicator {
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      width: auto;
      padding: 0.25rem;
      border-radius: 3px;
    }
    .product-info {
      padding-bottom: 1rem;
      padding-left: 6px;
    }
    .access-button {
      border-radius: 15px;
      background-color: var(--mainGreen);
      border: none;
      padding: 0.5rem 1rem;
      font-weight: 500;
      font-size: 13px;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
      color: white;
    }
    
  }
  .info{
    display: flex;
    align-items: center;
    background-color: #f9f9f9;
    padding: 8px 15px;
    border-radius: 4px;
    color: grey;
    font-size: 12px;
    .downloadList{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .download-button{
        border-radius: 5px;
        min-width: 140px;
        border: none;
        padding: 0.2rem 1rem;
        margin-bottom: 5px;
        font-weight: 500;
        font-size: 10px;
      }
    }
  }
}
</style>